export const INTEGER_NUMBER = 'INTEGER_NUMBER';
export const DECIMAL_NUMBER = 'DECIMAL_NUMBER';
export const STRING = 'STRING';
export const DATE_STRING = 'DATE_STRING';
export const EMAIL_STRING = 'EMAIL_STRING';
export const NONE = 'NONE';
